import { z } from 'zod/mini'

import type { TRoutes } from '~/types/routes'

export const checkoutRedirectToOptions = ['/settings/subscription/usage'] as const satisfies TRoutes[]

export const checkoutSearchSchema = z.object({
  clientSecret: z.optional(z.string()),
  payment_intent_client_secret: z.optional(z.string()),
  redirectTo: z.optional(z.enum(checkoutRedirectToOptions)),
})
